/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { useSuspenseQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';
import {
  Termine_KalenderTagesDatenResult,
  Termine_TermineError,
  Termine_Termine,
} from '@/gql/graphql';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { TerminWiederholung } from '@/domain/termine/shared/types/TerminWiederholung';
import { GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM } from '@/domain/termine/hooks/graphql/queries';

export function useTagesDaten(
  standortIds: string[],
  zeitraum: { von: string; bis: string },
) {
  const { data } = useSuspenseQuery<
    {
      termine_kalenderTagesDatenByStandortIdAndZeitraum: Termine_KalenderTagesDatenResult;
    },
    { standortIds: string[]; zeitraum: { von: string; bis: string } }
  >(GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM, {
    variables: { standortIds, zeitraum },
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  const result = data?.termine_kalenderTagesDatenByStandortIdAndZeitraum;
  const termineResult = result?.termine ?? [];
  const feiertage = result?.feiertage ?? [];

  const errors = termineResult.filter(
    (item): item is Termine_TermineError =>
      item.__typename === 'termine_generalError',
  );
  const error: string | null =
    errors.length > 0
      ? (Sentry.captureException(errors[0]), errors[0].message)
      : null;

  const termine: Termin[] = termineResult
    .filter(
      (termin): termin is Termine_Termine =>
        termin.__typename === 'termine_termine',
    )
    .map(
      (item) =>
        new Termin({
          beginn: item.beginn ?? '',
          datum: item.datum,
          ende: item.ende ?? '',
          id: item.id,
          idStandort: item.standortId,
          idTerminkalender: item.terminKalenderId ?? undefined,
          image: item.image ?? undefined,
          markierung: item.markierung,
          titel: item.titel,
          wiederholung: TerminWiederholung[item.wiederholung],
          wiederholungBis: item.wiederholungBis ?? undefined,
          beschreibung: item.termineDetails?.beschreibung ?? '',
          specials: item.termineDetails?.specials ?? '',
        }),
    );

  return {
    termine,
    feiertage,
    error,
  };
}
